module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pomodoro_bar_01.33fcd3d6.svg";